//import React, { Component } from 'react';

import React, { useContext, useEffect, useState } from "react";

import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
//import { UserContext } from "../store/userContext";
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";

export default function PasswordRecovery() {
    let navigate = useNavigate();
    //const { reCreate } = useContext(UserContext);
    const [isPosting, setIsPosting] = useState(false);
    const [form, setForm] = useState(
        {
            mobile: "",
        });
    useEffect(() => {
     
    }, []);


    const handlePosting = async (e) => {
        e.preventDefault();
        setIsPosting(true);
        if (form.mobile.length == 0) {
            toast.error('شماره تلفن همراه خود را وارد فرمایید', { theme: "colored" });
            return
        }

        await noronServices.RequestVerifyCode(form.mobile)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                toast.dark('کد تغییر کلمه عبور برای شما ارسال شد');
                navigate('/PrivecyCode', { state: { mobile: form.mobile } });
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    return (
        <>
            <div className="container col-xl-10 col-xxl-8 px-4 py-5">
                <div className="row align-items-center g-lg-5 py-5">

                    <div className="col-md-10 mx-auto col-lg-5">
                        <form asp-action="Login" className="p-4 p-md-5 border rounded-3 bg-light" method="post">
                            <div className="form-floating mb-3">
                                <input asp-for="mobile"
                                    type="number"
                                    name="mobile"
                                    value={form.Username}
                                    onChange={e => http.handleChange(e, form, setForm)}
                                    className="form-control"
                                    placeholder="شماره موبایل" autoComplete="off" />
                                <label asp-for="mobile">شماره موبایل</label>
                                <span asp-validation-for="mobile" className="text-danger"></span>
                            </div>
                            <button className="w-100 btn btn-lg btn-primary"

                                onClick={handlePosting}
                                disabled={isPosting}>
                                ارسال
                                {isPosting &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }
                            </button>
                            <hr className="my-4" />
                            <Link to="/login" className="text-decoration-none">ورود</Link>
                        </form>
                    </div>
                </div>
            </div>
        </>

    );

}
